import { render, staticRenderFns } from "./NotesPopupFullfilment.vue?vue&type=template&id=46a4cc06&scoped=true&"
import script from "./NotesPopupFullfilment.vue?vue&type=script&lang=js&"
export * from "./NotesPopupFullfilment.vue?vue&type=script&lang=js&"
import style0 from "./NotesPopupFullfilment.vue?vue&type=style&index=0&id=46a4cc06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a4cc06",
  null
  
)

export default component.exports